<template>
  <el-input class="number-input" v-model="modelValue" @input="inputAction"></el-input>
</template>

<script>
  export default {
    name: 'NumberInput',
    props: ['value'],
    data () {
      return {
        modelValue: this.value,
        preValue: this.value,
        regexPattern: `^\\d+$`
      }
    },
    methods: {
      inputAction: function (value) {
        if (value !== '') {
          const regex = RegExp(this.regexPattern)
          this.modelValue = regex.test(value) ? value : this.preValue
        } else {
          this.modelValue = value
        }
        this.preValue = this.modelValue
        this.$emit('input', this.modelValue)
      }
    },
    watch: {
      value () {
        this.modelValue = this.value
      }
    }
  }
</script>
